export const RouterName = {
    "所有教学活动模块":"Activity modules",
    "我的表现":"My performance",
    "表现":"performance",
    "选择活动类型":"Select Activity Type",
    "星星":"stars",
    "奖励":"Reward",
    "扣除":"Deduct",
    "新建":"Create",
    "奖励星星":"Reward stars",
    "扣除星星":"Deduct stars",
    "新建活动类型":"New activity type",
    "请选择星星数":"Please select the number of stars",
    "请输入星星数":"Please enter the number of stars",
    "选择分组批次":"Select grouping batch",
    "排行榜":"Ranking list",
    "课程人数":"Number of course members",
    "星星统计星":"Star statistics (stars)",
    "参与人数统计人":"Number of participants (person)",
    "星星卡活动":"Star card activity",
    "其他活动":"Other activities",
    "表现统计":"Statistics",
    "总星星":"Total stars",
    "第一小组":"Group one",
    "参与活动":"Participation",
    "星":"stars",
    "平台活动":"Platform activities",
    "当前排名":"Current ranking:",
    "总星星数":"Total stars",
    "此星星卡有效可以使用":"This star card is valid and can be used",
    "星星卡":"Star card",
    "返回首页":"Back to Home",
    "此星星卡无效":"This star card is invalid",
    "已被学生":"Student",
    "于":"has scanned on",
    "扫描了":"",
    "请选择活动类型":"Please select the activity type",
    "查看表现":"View performance",
    "扫码失败":"Scan code failed",
    "请选择一个活动类型":"Please select an activity type",
    "当前排行":"Current ranking",
    "参与活动数":"Number of activities",
    "得星记录":"Reward record",
    "今日表现榜":"Today's performance list",
    "总表现榜":"Overall performance list",
    "按姓名排序":"Sort by name",
    "按得星数排序":"Sort by the number of stars",
    "按学号排序":"Sort by student number",
    "继续奖励":"Continue to reward",
    "批量奖励":"Batch rewards",
    "操作成功":'Operation succeeded',
    "自定义":"Custom",
   
}